import { render, staticRenderFns } from "./ProductReadOnlyCmp.vue?vue&type=template&id=3ab2efac&scoped=true"
import script from "./ProductReadOnlyCmp.vue?vue&type=script&lang=js"
export * from "./ProductReadOnlyCmp.vue?vue&type=script&lang=js"
import style0 from "./ProductReadOnlyCmp.vue?vue&type=style&index=0&id=3ab2efac&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab2efac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ab2efac')) {
      api.createRecord('3ab2efac', component.options)
    } else {
      api.reload('3ab2efac', component.options)
    }
    module.hot.accept("./ProductReadOnlyCmp.vue?vue&type=template&id=3ab2efac&scoped=true", function () {
      api.rerender('3ab2efac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/serviceOroviderOrder/component/EditCmp/ProductReadOnlyCmp.vue"
export default component.exports